module.exports = __webpack_public_path__ + "img/wallet_mgr.8da2cd2c.png";